import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import Footer from '../util/Footer'
import HeaderInicio from '../util/headerInicio'
import CarrerasPostuladas from '../view/Inicio/CarrerasPostuladas'
import Instrucciones from '../view/Inicio/Instrucciones'
import { Menu } from '../view/PortalPostulante/Menu'
import Preguntas from '../view/Inicio/Preguntas'
import eCertResult from '../view/PortalPostulante/eCert/eCertResult'
import PacPat from '../view/PortalPostulante/PACPAT/PacPat'
import DescargaContrato from '../view/PortalPostulante/DescargaContrato/DescargaContrato'
import OnlyFirmaContrato from '../view/PortalPostulante/FirmaContrato/OnlyFirmaContrato'
import InicioPostExt from '../view/PostExt/Inicio/InicioPostExt'

export const AppProcesoMatricula = () => {
    return (
        <>
            {/* <HeaderInicio /> */}
            <div>
                <Switch>
                    <Route exact path="/preguntas" component={Preguntas} render={(props) => <Preguntas {...props} />}></Route>
                    <Route exact path="/carreras" component={CarrerasPostuladas} render={(props) => <CarrerasPostuladas {...props} />}></Route>
                    <Route exact path="/instrucciones" component={Instrucciones} render={(props) => <Instrucciones {...props} />}></Route>
                    <Route exact path="/matricula" component={Menu} render={(props) => <Menu {...props} />}></Route>
                    <Route exact path="/eCertResult" component={eCertResult} render={(props) => <eCertResult {...props} />}></Route>
                    <Route exact path="/PACPAT" component={PacPat} render={(props) => <eCertResult {...props} />}></Route>
                    <Route exact path="/DescargaContrato" component={DescargaContrato} render={(props) => <eCertResult {...props} />}></Route>
                    <Route exact path="/FirmaContrato" component={OnlyFirmaContrato} render={(props) => <eCertResult {...props} />}></Route>
                    <Route exact path="/InicioPostExt" component={InicioPostExt} render={(props) => <eCertResult {...props} />}></Route>
                    <Redirect to="/Inicio" />
                </Switch>
            </div>
            {/* <Footer /> */}

        </>
    )
}
